import {FaSatelliteDish} from 'react-icons/fa';

const LOCATION_PRESENTATIONS = {
    REPORTING_ALWAYS: {label: 'GPS active', tone: 'success'},
    REPORTING_APP_OPEN: {label: 'GPS active while app is open', tone: 'success'},
    REPORTING_STATUS_MISMATCH: {label: 'GPS reporting with a status mismatch', tone: 'warning'},
    STALE: {label: 'GPS report is stale', tone: 'warning'},
    OFF: {label: 'GPS tracking is off', tone: 'danger'},
    NEEDS_PERMISSION: {label: 'GPS permission is required', tone: 'danger'},
    NEVER_REPORTED: {label: 'GPS has not reported a location', tone: 'muted'},
};

export function getLocationPresentation(healthStatus) {
    return LOCATION_PRESENTATIONS[healthStatus] || LOCATION_PRESENTATIONS.NEVER_REPORTED;
}

function formatReportTime(timestamp) {
    if (!timestamp) return '';
    const value = new Date(timestamp);
    if (Number.isNaN(value.getTime())) return '';
    return new Intl.DateTimeFormat('en-AU', {
        dateStyle: 'short',
        timeStyle: 'short',
    }).format(value);
}

export default function WorkerLocationStatusIcon({tracking, workerName, onOpenMap}) {
    if (!tracking?.app_reported) return null;

    const presentation = getLocationPresentation(tracking.health_status);
    const timestamp = tracking.last_sent_at || tracking.last_attempt_at;
    const reportTime = formatReportTime(timestamp);
    const reportLabel = reportTime ? ` · Last report ${reportTime}` : '';
    const label = `${workerName} · ${presentation.label}${reportLabel}`;
    const accessibleLabel = onOpenMap ? `Show ${workerName} on map · ${presentation.label}${reportLabel}` : label;
    const Element = onOpenMap ? 'button' : 'span';

    return (
        <Element
            className={`scheduler-worker-gps scheduler-worker-gps--${presentation.tone}`}
            type={onOpenMap ? 'button' : undefined}
            role={onOpenMap ? undefined : 'img'}
            aria-label={accessibleLabel}
            title={accessibleLabel}
            onClick={onOpenMap}
        >
            <FaSatelliteDish aria-hidden="true" focusable="false" />
        </Element>
    );
}
